<template>
  <sc-taginput
    :allow-new="false"
    autocomplete
    :data="locallogisticProviders"
    field="name"
    @input="text => getFilteredTags(text, logisticProvidersModel)"
    :open-on-focus="true"
    v-model="logisticProvidersModel"
    placeholder="Selecione"
    :loading="loading">
      <template slot-scope="props">
        {{ props.option.name }}
      </template>    
  </sc-taginput>  
</template>

<script>
  import { Lodash } from '@intelipost-js/secure-providers';
  import { ScTaginput } from '@intelipost-js/secure-components';
  import { createNamespacedHelpers } from 'vuex';

  const { mapActions, mapState } = createNamespacedHelpers('logisticProviders');
  export default {
    name: 'sc-lp-taginput',
    props: {
      /**
       * Se ***true***, ele retorna as transportadoras ativas
       */
      active: {
        type: Boolean,
        default: true,
      },
      /**
       * @model
       */
      value: {
        type: Array,
        default: () => [],
      },
      formFields: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
        logisticProvidersModel: [],
        locallogisticProviders: [],
      };
    },
    watch: {
      value(value) {
        this.logisticProvidersModel = value;
      },
      logisticProvidersModel(logisticProvidersModel) {
        this.$emit('input', logisticProvidersModel);
      },
      formFields(value) {
        if (value.logisticProviderIds.length < 1 && this.value.length < 1) {
          this.locallogisticProviders = this.sortLp(Lodash.cloneDeep(this.logisticProviders));
        }
      },
    },
    computed: {
      ...mapState([
        'logisticProviders',
        'loading',
      ]),
    },
    methods: {
      ...mapActions([
        'getLogisticProviders',
      ]),
      filterSelectedLp(selected, listLp) {
        const serializedIds = selected.map(value => value.id);
        return listLp.filter(listItem => serializedIds.indexOf(listItem.id) < 0);
      },
      getFilteredTags(text, status) {
        this.locallogisticProviders = this.sortLp(this.logisticProviders
          .filter(state => !status.find(item => item.id === state.id)));
      },
      sortLp(lp) {
        return lp.sort((a, b) => {
          if (a.name.toLowerCase() < b.name.toLowerCase()) {
            return -1;
          }

          if (a.name.toLowerCase() > b.name.toLowerCase()) {
            return 1;
          }

          return 0;
        });
      },
    },
    created() {
      this.getLogisticProviders(this.active)
        .then((logisticProviders) => {
          const lp = Lodash.cloneDeep(logisticProviders);
          this.locallogisticProviders = this.sortLp(lp);
  
          if (this.value.length > 0) {
            this.logisticProvidersModel = Lodash.cloneDeep(this.value);
            this.locallogisticProviders = this
              .sortLp(this.filterSelectedLp(this.value, this.locallogisticProviders));
          }

          return logisticProviders;
        });
    },
    components: {
      ScTaginput,
    },
  };
</script>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-psl/features/list/components/ScLpTaginput.vue